@import '../../../../constants/spacing.module.less';

.todo-card {
  background-color: var(--gray-F9FAFB);
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 4px;
  padding: @space-24;
  height: 100%;
  max-width: 405px;
}

.card-content {
  flex: 1;
  margin-bottom: @space-16;
  text-align: left;
}

.card-title {
  margin-bottom: @space-12;
}

.card-description {
  line-height: 24px;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: var(--gray-E4E5E7);
  margin-bottom: @space-16;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: @space-8;
  font-size: 14px;
}

.learn-more-link {
  font-weight: 500;
}
